import { UserTranslator } from 'src/translators'
import { UserResponse } from 'src/types'
import { useGetUsersQuery } from 'src/types/generated'

export const useGetUsers = () => {
  const { loading, data, error, refetch } = useGetUsersQuery()

  return {
    loading,
    users:
      data && data.users && data.users.users
        ? UserTranslator.toUserEntities(
            data.users.users.filter((v): v is UserResponse => v !== null)
          )
        : [],
    error,
    refetch,
  }
}
